import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  // Map menu items to their correct routes
  const menuItems = [{
    label: 'Home',
    path: '/'
  }, {
    label: 'About',
    path: '/about'
  }, {
    label: 'Research',
    path: '/research'
  }, {
    label: 'Media & Blog',
    path: '/media-blog'
  }, {
    label: 'Support Us',
    path: '/support-us'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-196" data-mp="31e1sm3q1wizl">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-197" data-mp="36a0enknwpowu">
        <div className="flex items-center" data-id="element-198" data-mp="3baxuhqlg26v6">
          <a href="/" className="flex items-center" data-id="element-199" data-mp="3b81vdyxv1c55">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s957RAoqcksDJdCuVL5gqL/ChatGPT_Image_Sep_15%2C_2025%2C_05_13_32_PM.png" alt="CalMiR Logo" className="h-10 md:h-12" data-id="element-200" data-mp="3fayf5sz4zeao" />
            <span className="hidden md:inline-block ml-2 text-xs text-navy-600" data-id="element-201" data-mp="2rnuhwnhqcoha">
              California Institute for Microbiome Research
            </span>
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-202" data-mp="3fbcdyv8128q2">
          {menuItems.map(item => <a key={item.label} href={item.path} className="text-navy-700 hover:text-teal-600 transition-colors duration-200" data-id="element-203" data-mp="3fd6pjixesohh">
              {item.label}
            </a>)}
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-navy-700 hover:text-teal-600 transition-colors duration-200" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-204" data-mp="30m67qnarvi8o">
          {isMenuOpen ? <XIcon size={24} data-id="element-205" data-mp="3t90opa8drzhe" /> : <MenuIcon size={24} data-id="element-206" data-mp="1rdkzu5zy6xu8" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <nav className="md:hidden bg-white border-t border-gray-100 py-4" data-id="element-207" data-mp="1wd5zyjqutc8j">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-208" data-mp="1hnrrddv3qyu7">
            {menuItems.map(item => <a key={item.label} href={item.path} className="text-navy-700 hover:text-teal-600 transition-colors duration-200 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-209" data-mp="1mml3b1uqqhs9">
                {item.label}
              </a>)}
          </div>
        </nav>}
    </header>;
}